import TicketsScannerGroupedTicketItems from './GroupedTicketItems'

const TicketsScannerGuestInfo = ({ guest, groupedTicketItems }) => {
  return (
    <div className="row">
      <div className="col-md-6">
        <h2>{guest.name}</h2>
        <p>{guest.email}</p>
        <p>
          <b>{I18n.t("tickets_scanner.owner_info.comment")}: </b>
          {guest.comment}
        </p>
        <p>
          <b>{I18n.t("tickets_scanner.owner_info.guest_list_group")}: </b>
          {guest.guest_list_group}
        </p>
        <p>
          <b>{I18n.t("tickets_scanner.owner_info.guest_list")}: </b>
          {guest.guest_list}
        </p>
      </div>
      <div className="col-md-6">
        {groupedTicketItems.length > 0 ? (
          <TicketsScannerGroupedTicketItems
            groupedTicketItems={groupedTicketItems}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  )
}

export default TicketsScannerGuestInfo
